import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-llama-three-point-three',
  templateUrl: './llama-three-point-three.component.html',
  styleUrls: ['./llama-three-point-three.component.scss']
})
export class LlamaThreePointThreeComponent {
  constructor(public dialogRef: MatDialogRef<LlamaThreePointThreeComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
